import { format } from "date-fns";
import {
  Component,
  OnInit,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  OnDestroy,
} from "@angular/core";
import { CallCenterService } from "src/app/services/call-center.service";
import { CommonService } from "src/app/services/common.service";
import { CommonMethods } from "src/app/shared/CommonMethods";
import { Subscription } from "rxjs";
import { AskApolloService } from "src/app/services/ask-apollo.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MessageServiceService } from "src/app/services/message-service.service";
import { AttachSession } from "protractor/built/driverProviders";
import { LeadsService } from "src/app/services/leads.service";
import { resolve } from "url";
import { MessageService } from "primeng/api";

@Component({
  selector: "app-call-drop",
  templateUrl: "./call-drop.component.html",
  styleUrls: ["./call-drop.component.scss"],
})
export class CallDropComponentimplements implements OnInit, OnDestroy {
  enquiryForm: FormGroup;

  //@Input() formReset: boolean;

  //@Input() callerStatusAutoId: number;
  //@Input() selectedCallStatusId: any;

  //@Output() formSubmit = new EventEmitter<any>();

  selectedAppointmentType = 1;
  selectedHospitalType = 2;
  minDate: Date = new Date();
  yearRange = "";
  selectedTime: string;
  callDropFormGroup: FormGroup;
  formSubmitted: boolean;
  loadingFlag: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageServiceService,
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private askApolloService: AskApolloService,
    private leadsService: LeadsService, //private datePipe: DatePipe,
    private ref: ChangeDetectorRef
  ) {
    this.callDropFormGroup = this.formBuilder.group({
      // callbackDateTime: ["", Validators.required],
      remark: ["", Validators.required],
    });
    this.callDropFormGroup.reset({
      remark: "",
    });
  }

  ngOnInit() {
    // this.initiateForm();
    this.selectedTime = this.times[0];
  }

  times: string[] = ["01:00", "01:30"];

  ngOnDestroy() {
    //this.PackageEnquiryData.unsubscribe();
  }

  citiesData: any[];
  clinicsData: any[];

  ngOnChanges() {
    // if (this.formReset) {
    //   if (this.enquiryForm) this.resetForm();
    // }
  }

  // initiateForm() {
  //   this.enquiryForm = this.fb.group({
  //     PatientName: ['', [Validators.required]],
  //     MobileNumber: ["", [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
  //     Email: ["", [Validators.pattern(/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)]],
  //     City: ['', [Validators.required]],
  //     Clinics: ['', [Validators.required]],
  //     PackageType: ['', [Validators.required]],
  //     AGE: ['', [Validators.required, Validators.min(1), Validators.max(120)]],
  //     EDD: [''],
  //     IsPackageExplained: ['', [Validators.required]],
  //     PaymentMode: ['', [Validators.required]],
  //     CustomerQuery: [''],
  //     Anyspecialrequest: [''],
  //     UnitVisitAppointment: ['']
  //   })
  // }

  resetForm() {
    this.enquiryForm.reset();
    this.enquiryForm.get("callbacktime").setValue("");
  }

  getSubDispositionsOnId(event) {
    if (event == 35) {
      this.enquiryForm.get("EDD").enable();
    } else {
      this.enquiryForm.get("EDD").disable();
    }
  }
  syncCallHistory() {
    let leadData = JSON.parse(
      localStorage.getItem("CurrentOutBoundCallMobileNumber")
    );

    let payload = {
      val: leadData.leadId,
    };
    this.leadsService.SyncCallData(leadData.leadId).subscribe(
      (res: any) => {
        if (res) {
          this.messageService.showSuccess("Call history  Status synced");
        } else {
          this.messageService.showWarning(
            "issue while syncing  the lead history"
          );
        }
        //this.disableOrEnableForm(1);
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to update call history status, An error occur while updating status."
        );
        // this.disableOrEnableForm(1);
      }
    );
  }

  UpdateCallStatusDetails(formData) {
    if (this.callDropFormGroup.valid) {
      this.callDropFormGroup.enable();
      let formDataValues = this.callDropFormGroup.value;

      //  Call Back Later = 25,
      // Call In progress = 29,
      // Package Enquiry : 30,
      // Irrelevant Lead = 24,
      // Call Drop = 18,
      // Not Responding = 17
      // Number Not Valid = 21

      let leadData = JSON.parse(
        localStorage.getItem("CurrentOutBoundCallMobileNumber")
      );
      if (leadData == null || leadData == undefined) {
        let leadData1 = JSON.parse(
          localStorage.getItem("CurrentInBoundCallDetails")
        );
        debugger;
        this.loadingFlag = true;

        let payload = {
          leadId: 0,
          callsubstatus: 18,
          remark: formDataValues.remark,
          CallerNumber: leadData1.patientMobileNumber.replace(/^\+91/, ""),
          isActicityLead: false,
        };
        this.askApolloService.UpdateCallerStatus(payload).subscribe(
          (res: any) => {
            if (res && res != undefined) {
              alert("Call Drop Status Updated");
              this.messageService.showSuccess(res.message);

              this.loadingFlag = false;
              //  this.formSubmitted = true;
              //  this.syncCallHistory();
              this.callDropFormGroup.reset();
              this.commonService.setBooleanValue(false); // Set the value you want to share
            } else {
              this.messageService.showWarning("issue while updating the lead");
            }
            //this.disableOrEnableForm(1);
          },
          (error) => {
            this.messageService.showErrorMessage(
              "Unable to update call drop status, An error occur while updating status."
            );
            // this.disableOrEnableForm(1);
          }
        );
      } else {
        let id = leadData.id;
        debugger;
        this.loadingFlag = true;

        var IsActivity = localStorage.getItem("IsActivityLead");
        let payload = {
          leadId: leadData.leadId,
          callsubstatus: 18,
          remark: formDataValues.remark,
          CallerNumber: leadData.phoneNo,
          isActicityLead: IsActivity,
        };
        this.askApolloService.UpdateCallerStatus(payload).subscribe(
          (res: any) => {
            if (res) {
              alert("Call Drop Status Updated");
              this.messageService.showSuccess(res.message);
              // this.messageService.showWarning(res.message);

              this.loadingFlag = false;

              // this.formSubmitted = true;
              //  this.syncCallHistory();
              this.callDropFormGroup.reset();
              this.commonService.setBooleanValue(false); // Set the value you want to share
            } else {
              this.messageService.showWarning("issue while updating the lead");
            }
            //this.disableOrEnableForm(1);
          },
          (error) => {
            this.messageService.showErrorMessage(
              "Unable to update call drop status, An error occur while updating status."
            );
            // this.disableOrEnableForm(1);
          }
        );
      }
    } else {
      this.messageService.showWarning("Please Fill Fields");
    }
  }
}
